import { useEffect, useRef, useState } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import styled from "styled-components";
import mapSettingsOne from "../../data/map/mapSettingsOne";

let apiKey = process.env.REACT_APP_GOOGLE_MAPS_KEY;

const Map = styled.div`
  width: 100%;
  height: 100%;
`;

function MapWithDraggableMarker2({
  value,
  zoom = 16,
  onChange,
  forcedMapUpdateCode,
  disableDrag,
}) {
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const markerRef = useRef(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {}, [isLoading]);

  useEffect(() => {
    if (!apiKey) {
      setError("Google Maps API key is required");
      setIsLoading(false);
      return;
    }

    const initMap = async () => {
      try {
        const loader = new Loader({
          apiKey,
          version: "weekly",
          libraries: ["places"],
        });

        await loader.load();

        setupMap();

        function setupMap() {
          if (mapRef.current) {
            // Initialize map
            mapInstance.current = new window.google.maps.Map(mapRef.current, {
              center: value,
              zoom,
              styled: mapSettingsOne,
              //   styles: [
              //     {
              //       featureType: "all",
              //       elementType: "geometry.fill",
              //       stylers: [{ weight: "2.00" }],
              //     },
              //     {
              //       featureType: "all",
              //       elementType: "geometry.stroke",
              //       stylers: [{ color: "#9c9c9c" }],
              //     },
              //     {
              //       featureType: "all",
              //       elementType: "labels.text",
              //       stylers: [{ visibility: "on" }],
              //     },
              //     {
              //       featureType: "landscape",
              //       elementType: "all",
              //       stylers: [{ color: "#f2f2f2" }],
              //     },
              //     {
              //       featureType: "landscape",
              //       elementType: "geometry.fill",
              //       stylers: [{ color: "#ffffff" }],
              //     },
              //     {
              //       featureType: "landscape.man_made",
              //       elementType: "geometry.fill",
              //       stylers: [{ color: "#ffffff" }],
              //     },
              //     {
              //       featureType: "poi",
              //       elementType: "all",
              //       stylers: [{ visibility: "on" }],
              //     },
              //     {
              //       featureType: "poi",
              //       elementType: "labels.text.fill",
              //       stylers: [{ color: "#333333" }],
              //     },
              //     {
              //       featureType: "poi",
              //       elementType: "labels.text.stroke",
              //       stylers: [{ color: "#ffffff" }],
              //     },
              //     {
              //       featureType: "poi.business",
              //       elementType: "all",
              //       stylers: [{ visibility: "on" }],
              //     },
              //     {
              //       featureType: "poi.establishment",
              //       elementType: "all",
              //       stylers: [{ visibility: "on" }],
              //     },
              //     {
              //       featureType: "poi.place_of_worship",
              //       elementType: "all",
              //       stylers: [{ visibility: "on" }],
              //     },
              //     {
              //       featureType: "poi.school",
              //       elementType: "all",
              //       stylers: [{ visibility: "on" }],
              //     },
              //     {
              //       featureType: "road",
              //       elementType: "all",
              //       stylers: [{ saturation: -100 }, { lightness: 45 }],
              //     },
              //     {
              //       featureType: "road",
              //       elementType: "geometry.fill",
              //       stylers: [{ color: "#eeeeee" }],
              //     },
              //     {
              //       featureType: "road",
              //       elementType: "labels.text.fill",
              //       stylers: [{ color: "#7b7b7b" }],
              //     },
              //     {
              //       featureType: "road",
              //       elementType: "labels.text.stroke",
              //       stylers: [{ color: "#ffffff" }],
              //     },
              //     {
              //       featureType: "road.highway",
              //       elementType: "all",
              //       stylers: [{ visibility: "simplified" }],
              //     },
              //     {
              //       featureType: "road.arterial",
              //       elementType: "labels.icon",
              //       stylers: [{ visibility: "off" }],
              //     },
              //     {
              //       featureType: "transit",
              //       elementType: "all",
              //       stylers: [{ visibility: "off" }],
              //     },
              //     {
              //       featureType: "water",
              //       elementType: "all",
              //       stylers: [{ color: "#46bcec" }, { visibility: "on" }],
              //     },
              //     {
              //       featureType: "water",
              //       elementType: "geometry.fill",
              //       stylers: [{ color: "#c8d7d4" }],
              //     },
              //     {
              //       featureType: "water",
              //       elementType: "labels.text.fill",
              //       stylers: [{ color: "#070707" }],
              //     },
              //     {
              //       featureType: "water",
              //       elementType: "labels.text.stroke",
              //       stylers: [{ color: "#ffffff" }],
              //     },
              //   ],
              disableDefaultUI: false,
              zoomControl: true,
              mapTypeControl: false,
              scaleControl: true,
              streetViewControl: false,
              rotateControl: false,
              fullscreenControl: true,
            });

            // Create draggable marker
            markerRef.current = new window.google.maps.Marker({
              position: value,
              map: mapInstance.current,
              draggable: disableDrag ? false : true,
              title: "Drag me to set location",
              animation: window.google.maps.Animation.DROP,
              icon: {
                path: window.google.maps.SymbolPath.CIRCLE,
                scale: 8,
                fillColor: "#3B82F6",
                fillOpacity: 1,
                strokeWeight: 2,
                strokeColor: "#ffffff",
              },
            });

            // Add drag event listener
            markerRef.current.addListener("dragend", (event) => {
              if (event.latLng) {
                const newPosition = {
                  lat: event.latLng.lat(),
                  lng: event.latLng.lng(),
                };
                onChange(newPosition);
              }
            });

            // Add click event to map to move marker
            mapInstance.current.addListener("click", (event) => {
              if (event.latLng && markerRef.current) {
                const newPosition = {
                  lat: event.latLng.lat(),
                  lng: event.latLng.lng(),
                };
                markerRef.current.setPosition(event.latLng);
                onChange(newPosition);
              }
            });

            setIsLoading(false);
          }
        }
      } catch (err) {
        console.error("Error loading Google Maps:", err);
        setError("Failed to load Google Maps");
        setIsLoading(false);
      }
    };

    initMap();

    return () => {
      if (markerRef.current) {
        markerRef.current.setMap(null);
      }
    };
  }, [apiKey, zoom, forcedMapUpdateCode]);

  if (error || !apiKey) {
    console.error(error);
    return null;
  }

  return <Map ref={mapRef} />;
}

export default MapWithDraggableMarker2;
